<div class="spacerWrapper" fxLayout="column">
    <h1 mat-dialog-title class="dialogTitle">{{ title }}</h1>

    <div mat-dialog-content>
        <form [formGroup]="categoryEditorForm" class="grid-container">
            <div class="inputContainer categoryName">
                <label>Name</label>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="Name" />
                </mat-form-field>
                <mat-checkbox formControlName="Active" aria-label="Active"> Active </mat-checkbox>
            </div>
        </form>
    </div>

    <div class="spacer" fxFlexFill></div>
    <div class="actions">
        <div class="error-messages" fxLayout="column" fxLayoutAlign="start end">
            <mat-error *ngIf="Name.invalid && !Name.errors?.isNameTaken && Name.touched">
                <mat-icon aria-hidden="false" aria-label="Error: Missing Category Name">error</mat-icon>
                Missing Category Name.
            </mat-error>
            <mat-error *ngIf="Name.errors?.isNameTaken && Name.touched">
                <mat-icon aria-hidden="false" aria-label="Error: Category Name chosen is already in use.">error </mat-icon>
                Category Name chosen is already in use.
            </mat-error>
        </div>

        <div mat-dialog-actions align="end">
            <button mat-raised-button type="submit" color="primary" (click)="onSubmit(categoryEditorForm.value)">OK</button>
            <button mat-raised-button type="button" (click)="onNoClick()">Cancel</button>
        </div>
    </div>
</div>
